module.exports = __webpack_public_path__ + "img/electric_enabled_selecteds.252ec3c4.svg";